import { render } from "./DaysOfTheWeek.vue?vue&type=template&id=12051f58&scoped=true"
import script from "./DaysOfTheWeek.vue?vue&type=script&lang=js"
export * from "./DaysOfTheWeek.vue?vue&type=script&lang=js"

import "./DaysOfTheWeek.vue?vue&type=style&index=0&id=12051f58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12051f58"]])

export default __exports__